import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PasswordGeneratorService {
  private readonly LOWERCASE = 'abcdefghijklmnopqrstuvwxyz';
  private readonly UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  private readonly NUMBERS = '0123456789';
  private readonly SYMBOLS = '!@#$%^&*()_+-=[]{}|;:,.<>?';

  private readonly PASSWORD_LENGTH = 10;

  /**
   * Generates a secure password with:
   * - 10 characters
   * - At least one lowercase letter
   * - At least one uppercase letter
   * - At least one number
   * - At least one symbol
   * - Random positions for each character type
   */
  generate(): string {
    const allChars = this.LOWERCASE + this.UPPERCASE + this.NUMBERS + this.SYMBOLS;

    // Ensure at least one character from each required type
    const requiredChars = [
      this.getRandomChar(this.LOWERCASE),
      this.getRandomChar(this.UPPERCASE),
      this.getRandomChar(this.NUMBERS),
      this.getRandomChar(this.SYMBOLS)
    ];

    // Fill remaining positions with random characters from all types
    const remainingLength = this.PASSWORD_LENGTH - requiredChars.length;
    const randomChars: string[] = [];

    for (let i = 0; i < remainingLength; i++) {
      randomChars.push(this.getRandomChar(allChars));
    }

    // Combine and shuffle all characters
    const passwordChars = [...requiredChars, ...randomChars];
    return this.shuffleArray(passwordChars).join('');
  }

  private getRandomChar(chars: string): string {
    const randomIndex = Math.floor(Math.random() * chars.length);
    return chars[randomIndex];
  }

  private shuffleArray<T>(array: T[]): T[] {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }
}
